import React, { useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Sidebar() {
  const navRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Set active nav item based on current path on mount and on route change
  useEffect(() => {
    const items = navRef.current.querySelectorAll("li.nav-item");
    items.forEach((item) => item.classList.remove("active"));

    items.forEach((item) => {
      const anchor = item.querySelector("a");
      if (anchor && anchor.getAttribute("href") === location.pathname) {
        item.classList.add("active");
      }
    });
  }, [location.pathname]);

  // Generic handler to handle nav clicks
  const handleNavClick = (path) => (e) => {
    e.preventDefault();

    const items = navRef.current.querySelectorAll("li.nav-item");
    items.forEach((item) => item.classList.remove("active"));

    // Add active to the parent <li> of the clicked <a>
    e.currentTarget.parentElement.classList.add("active");

    navigate(`/${path}`);
  };

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul ref={navRef} className="nav">
        <li className="nav-item nav-b">
          <a
            className="nav-link back-b"
            href="/dashboard"
            onClick={handleNavClick("dashboard")}
          >
            <i className="icon-grid menu-icon"></i>
            <span className="menu-title">Dashboard</span>
          </a>
        </li>

        {sessionStorage.getItem("ApplicationStatus") === "NO" && (
          <li className="nav-item nav-b">
            <a
              className="nav-link back-b"
              href="/student-info"
              onClick={handleNavClick("student-info")}
            >
              <i className="fa fa-check-circle menu-icon"></i>
              <span className="menu-title">Click Here to Apply</span>
            </a>
          </li>
        )}

        {sessionStorage.getItem("ApplicationStatus") === "YES" && sessionStorage.getItem("CLASS_10_PAYMENT_ON_OFF") === "ON" &&
          (sessionStorage.getItem("PaymentStatus") === "NO" ||
            sessionStorage.getItem("PaymentStatus") === "F") && (
            <li className="nav-item nav-b">
              <a
                className="nav-link back-b"
                href="/student-payment"
                onClick={handleNavClick("student-payment")}
              >
                <i className="fa fa-credit-card menu-icon"></i>
                <span className="menu-title">Click Here for Payment</span>
              </a>
            </li>
          )}
      </ul>
    </nav>
  );
}

export default Sidebar;
